import { useCallback } from "react";
import SbuxStyledTableCell from "../../../../../components/SbuxTable/SbuxStyledTableCell";
import { useAppSelector } from "../../../../../store/types";
import SbuxStyledTableRow from "../../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxTooltip from "../../../../../components/SbuxTooltip";
import { ellipse, getTitleForEllipse } from "../../../../../utils/stringUtil";
import { getLastUpdated } from "../../../utils";
import { formatTimeString } from "../../../../../utils/dateUtil";
import styles from "../../styles";
import useCss from "../../../../../hooks/useCss";
import { getTimezoneSelector } from "../../../../../selectors/settingsSelector";

interface Props {
  row: Record<string, unknown>;
  handleEditRowClick: (row: Record<string, unknown>) => void;
}

const TemporaryMsgRow = ({ row, handleEditRowClick }: Props) => {
  const classes = useCss(styles);
  const timezone = useAppSelector(getTimezoneSelector);

  const handleEditClick = useCallback(() => {
    handleEditRowClick(row);
  }, [handleEditRowClick, row]);

  return (
    <SbuxStyledTableRow isHighlighted={row.highLight as boolean | undefined}>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {String(row["sequenceNumber"] ?? "")}
      </SbuxStyledTableCell>
      <SbuxTooltip
        title={getTitleForEllipse(row.description as string | undefined)}
        placement="right"
      >
        <SbuxStyledTableCell
          className={classes.cellFocus}
          onClick={handleEditClick}
        >
          {ellipse(
            row["description"] as string | null | undefined,
            Number(process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS),
          )}
        </SbuxStyledTableCell>
      </SbuxTooltip>

      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {String(row["startDate"] ?? "")}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {formatTimeString(row["startTime"] as string | undefined)}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {row["endDate"]
          ? String(row["endDate"])
          : row.status !== "Draft"
            ? "No end date"
            : ""}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {row["endTime"]
          ? formatTimeString(row["endTime"] as string | undefined)
          : row.status !== "Draft"
            ? "No end time"
            : ""}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {String(row["status"] ?? "")}
      </SbuxStyledTableCell>
      <SbuxStyledTableCell
        className={classes.cellFocus}
        onClick={handleEditClick}
      >
        {getLastUpdated(row, timezone)}
      </SbuxStyledTableCell>
    </SbuxStyledTableRow>
  );
};

export default TemporaryMsgRow;
